import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useEdgeApi } from "@/composables/useEdgeApi";
import { useViewContextStore } from "@/stores/viewContext";
import type { WearableSummary } from "@/types/api";

export const useWearableSummaryStore = defineStore("wearableSummary", () => {
    const edgeApi = useEdgeApi();
    const viewContext = useViewContextStore();

    const summary = ref<WearableSummary | null>(null);
    // Only assigned wearables warrant a warning; falls back to low until the backend sends lowAssigned.
    const lowBatteryCount = computed(
        () => summary.value?.battery.lowAssigned ?? summary.value?.battery.low ?? 0,
    );

    // Keeps the last summary on failure so the badge doesn't flicker off on a blip.
    // Scoped to the current venue so the count matches the Wearables list.
    const fetchSummary = async () => {
        const venueId = viewContext.venueId;
        if (!venueId) return;
        try {
            const response = await edgeApi.get<WearableSummary>("/wearables/summary", {
                params: { venueId },
            });
            // Drop a response for a venue the user has already switched away from.
            if (viewContext.venueId === venueId) summary.value = response.data;
        } catch (error) {
            console.error("Failed to fetch wearable summary:", error);
        }
    };

    return { summary, lowBatteryCount, fetchSummary };
});
